import React from "react";
import { Switch, Slider, Chip, Box, Skeleton } from "@mui/material";
import Masonry from "react-masonry-css";
import { useNavigate } from "react-router-dom";

import sanitizeUrl from "../../utils/sanitizeUrl";

// Importaciones de íconos y recursos
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import CloseIcon from "@mui/icons-material/Close";
import placeholderImg from "../../assets/img/placeholder.jpg";

// Importaciones de estilos
import "../../assets/css/Shop/index.css";

// Importaciones de utilidades
import { formatNumber } from "../../utils/formatNumber";
import SvgComponent from "../Img/SvgComponent";

const ShopMainSection = ({
    subCategories,
    loadingSubCat,
    selectedCheckboxes,
    handleCheckboxChange,
    filters,
    setFilters,
    value,
    handleChange,
    products,
    loading,
    loadingMoreProduct,
    loadingMore,
    loadingText,
    viewFilters,
    animationClass,
    handleClose,
    applyFilters,
    width,
    initialUrl
}) => {
    const navigate = useNavigate();
    
    return (
    <div className="section-shop mt-md-5 mb-5">
        <div className="col-md-10 offset-md-1 col-12">
            <div className="row">
                <div className="col-lg-3 col-md-4 col-12 pe-xl-5">
                    <div
                        className={`sidebar-filters d-md-block d-none ${
                            viewFilters && width < 767 ? animationClass : ""
                        }`}
                    >
                        <div className="w-100 mb-4 px-4">
                            <h2>Filtros</h2>
                        </div>

                        <button onClick={handleClose} type="button" className="btn btn-close-filters d-md-none">
                            <CloseIcon />
                        </button>

                        <form className="form-filters">
                            <div className="form-group d-md-block d-none">
                                <button onClick={applyFilters} type="button" className="btn btn-filter-primary">
                                    Aplicar filtros
                                </button>
                                <button onClick={() => window.location.href = initialUrl} type="button" className="btn btn-filter-secondary">
                                    Limpiar
                                </button>
                            </div>
                            <div className="w-100 my-4">
                                <h3>Subcategorías</h3>
                            </div>
                            <div className="form-group checkbox-group">
                                {loadingSubCat ? (
                                    Array.from({ length: 5 }).map((_, index) => (
                                        <Skeleton
                                            key={index}
                                            className="checkbox-category"
                                            variant="rectangular"
                                            height={40}
                                        />
                                    ))
                                ) : (
                                    subCategories.map((item) => (
                                        <label
                                            key={item.uid}
                                            className="checkbox-category"
                                            style={{
                                                backgroundColor: selectedCheckboxes.includes(item.uid)
                                                    ? "#000"
                                                    : "#F3F3F2",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                name="subcategory[]"
                                                onChange={() => handleCheckboxChange(item.uid)}
                                                value={item.uid}
                                                checked={selectedCheckboxes.includes(item.uid)}
                                            />
                                            {/* <div className="icon">
                                                <FavoriteBorderIcon
                                                    style={{
                                                        color: selectedCheckboxes.includes(item.uid)
                                                            ? "#fff"
                                                            : "#707070",
                                                    }}
                                                />
                                            </div> */}
                                            <SvgComponent
                                            className={
                                                selectedCheckboxes.includes(item.uid) ? "active" : ""
                                            } 
                                            url={`uploads/categories/${item.image}`} 
                                            />
                                            <span
                                                style={{
                                                    color: selectedCheckboxes.includes(item.uid) ? "#fff" : "#808080",
                                                }}
                                            >
                                                {item.name}
                                            </span>
                                        </label>
                                    ))
                                )}
                            </div>

                            <div className="filter-switch-group mt-5 mb-4">
                                <div className="filter-switch w-100">
                                    <label>Envío gratis</label>
                                    <Switch
                                        onChange={(event) =>
                                            setFilters((prevFilters) => ({
                                                ...prevFilters,
                                                sendFree: event.target.checked,
                                            }))
                                        }
                                        name={"sendFree"}
                                    />
                                </div>
                                <div className="filter-switch w-100">
                                    <label>Entrega el mismo día</label>
                                    <Switch
                                        onChange={(event) =>
                                            setFilters((prevFilters) => ({
                                                ...prevFilters,
                                                deliveryToday: event.target.checked,
                                            }))
                                        }
                                        name={"deliveryToday"}
                                    />
                                </div>
                            </div>

                            <div className="w-100 mb-3 mt-5">
                                <h3 className="mb-0">Precio</h3>
                                <label>Rango de precios</label>
                            </div>
                            {!loading && products?.products?.length > 0 ? (
                                <div className="filter-range-group">
                                    <Slider
                                        className="filter-range"
                                        min={products.priceRange.minPrice}
                                        max={products.priceRange.maxPrice}
                                        value={value}
                                        onChange={handleChange}
                                        name="limitPrice"
                                        valueLabelDisplay="auto"
                                    />

                                    <h4
                                        style={{
                                            fontSize: "20px",
                                            color: "#707070",
                                        }}
                                        className="text-center"
                                    >
                                        <strong>${value[0].toLocaleString()}</strong> -{" "}
                                        <strong>${value[1].toLocaleString()}</strong>
                                    </h4>
                                </div>
                            ) : (
                                <></>
                            )}
                        </form>

                        <div className="form-group footer-filters-shop d-md-none">
                            <button onClick={applyFilters} type="button" className="btn w-100 btn-filter-primary">
                                Aplicar filtros
                            </button>
                            <button onClick={() => window.location.href = initialUrl} type="button" className="btn w-100 btn-filter-secondary">
                                Limpiar
                            </button>
                        </div>
                    </div>
                </div>

                <div className="col-lg-9 col-md-8 col-12">
                    <Masonry
                        breakpointCols={{
                            default: 3,
                            1200: 2,
                        }}
                        className="my-masonry-grid"
                        columnClassName="my-masonry-grid_column"
                        style={{
                            gap: loading ? "20px":"0px",
                        }}
                    >
                        {loading ? (
                            Array.from({ length: 6 }).map((_, index) => (
                                <Skeleton
                                    key={index}
                                    variant="rectangular"
                                    height={`${Math.floor(Math.random() * (500 - 200 + 1)) + 200}px`}
                                    className="card-product"
                                    style={{
                                        width: "100%",
                                        maxWidth: "100%",
                                        marginBottom: "20px",
                                    }}
                                />
                            ))
                        ) : (
                            products.products?.map((item, index) => (
                                <Box
                                    key={index}
                                    className="card-product"
                                    sx={{
                                        width: "100%",
                                        maxWidth: "100%",
                                        marginBottom: "20px",
                                    }}
                                    onClick={() => navigate(`/product/${item.uid}/${sanitizeUrl(item.title)}`)}
                                >
                                    <div
                                        className="card-product__header"
                                        style={{
                                            height: "auto",
                                            padding: "0px",
                                        }}
                                    >
                                        <button className="btn btn-favorite">
                                            <FavoriteBorderIcon />
                                        </button>
                                        <img
                                            className="w-100"
                                            src={
                                                products.products?.length > 0 && item.images.length > 0
                                                    ? `${process.env.REACT_APP_API_BASE_URL}/uploads/${item.images[0].url}`
                                                    : placeholderImg
                                            }
                                            alt={`image-${index}`}
                                        />
                                        <Chip className="chip-sendFree" label="Envío GRATIS" color="success" />
                                    </div>
                                    <div className="card-product__body" style={{ padding: "16px" }}>
                                        <h5>{item.title}</h5>
                                        <p
                                            style={{
                                                fontSize: "14px",
                                            }}
                                        >
                                            <LocalShippingIcon
                                                className="pe-2"
                                                style={{ color: "#4BFF8E" }}
                                            />{" "}
                                            Recíbelo hoy o programado
                                        </p>
                                        <p className="card-product__price">$ {formatNumber(Number(item.price))}</p>
                                    </div>
                                </Box>
                            ))
                        )}
                        {loadingMore &&
                            Array.from({ length: 3 }).map((_, index) => (
                                <Skeleton
                                    key={index}
                                    variant="rectangular"
                                    height={300}
                                    className="card-product"
                                    style={{
                                        width: "100%",
                                        maxWidth: "100%",
                                        marginBottom: "20px",
                                        marginLeft: "20px",
                                        marginRight: "20px",
                                    }}
                                />
                        ))}
                    </Masonry>

                    <div className="col-12 text-center">
                        <button
                            style={{
                                minWidth: "210px",
                            }}
                            onClick={loadingMoreProduct}
                            className="btn rounded-pill px-4 btn-load-more text-white bg-black"
                            type="button"
                            disabled={loadingMore}
                        >
                            {loadingText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
)};

export { ShopMainSection };